/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2, IconButton, Link, Typography} from "@mui/material";
import logo from "../../../../Recursos/logo_barra.svg";
import {useNavigate} from "react-router-dom";
import icono_facebook from "../../../../Recursos/icono_facebook.svg";
import {Close, WhatsApp} from "@mui/icons-material";
import {LINKWHATSAPP, REDES, SECCIONES} from "../../../../Constantes";
import {irUrl} from "../../../../Utilidades/irUrl";


const redes = [
    {imagen: icono_facebook, alt: 'Facebook', url: 'https://www.facebook.com/sonarsassaludocupacionaldenarino'},
];

const Contenido_Barra_Cell = ({setOpen}) => {

    const navigate = useNavigate()

    return (
        <Grid2 container sx={{position: 'relative', height: '100vh'}}>

            <Grid2
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{position: 'absolute', top: 0}}>

                <Grid2 container size={12}>
                    <IconButton onClick={() => setOpen(false)} sx={{p: 0}}>
                        <Close sx={{fill: '#fff', fontSize: 35, m: 2}}/>
                    </IconButton>
                </Grid2>


                <Grid2 container size={12}
                       sx={{mt: 4}}>
                    {SECCIONES.map((pagina) => (
                        <Grid2
                            onClick={() => {
                                setOpen(false)
                                setTimeout(() => {
                                    navigate('/' + pagina)
                                }, 500)
                            }
                            }
                            container
                            justifyContent="center"
                            size={12}
                            key={pagina.id}
                        >
                            <Typography sx={{color: "white", fontSize: 18, fontWeight: 600}}>
                                {pagina}
                            </Typography>
                        </Grid2>
                    ))}
                </Grid2>

                <Grid2 container
                       justifyContent="center"
                       size={12}
                       sx={{mt: 6}}
                >

                    <Button
                        onClick={() => irUrl(LINKWHATSAPP)}
                        startIcon={<WhatsApp/>}
                        sx={{color: 'white', fontSize: 18, fontWeight: 600}}>
                        Más Información
                    </Button>

                </Grid2>

            </Grid2>

            <Grid2
                container
                justifyContent="center"
                alignItems="center"

                sx={{position: 'absolute', bottom: 0, pb: 8, width: '100%'}}
            >
                <Grid2
                    container
                    justifyContent="center"
                    size={12}>
                    <img

                        onClick={() => navigate('/Home')}
                        src={logo}
                        width="180"
                        height="auto"
                        style={{cursor: 'pointer'}}
                    />
                </Grid2>

                <Grid2
                    container
                    justifyContent="center"
                    spacing={4}
                    size={12}
                    sx={{pt: 4}}
                >
                    {REDES.map((red, index) => (
                        <Link

                            key={index}
                            target="_blank"
                            rel="noopener"
                            onClick={() => irUrl(red.link)}
                            sx={{cursor: 'pointer'}}
                        >
                            <img src={red.img} alt={red.alt} width={34}/>
                        </Link>
                    ))}
                </Grid2>
            </Grid2>
        </Grid2>

    )

}
export default Contenido_Barra_Cell;